import { render, staticRenderFns } from "./LayananList.vue?vue&type=template&id=de0817ba"
import script from "./LayananList.vue?vue&type=script&lang=js"
export * from "./LayananList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports